import _get from 'lodash/get'
import _reduce from 'lodash/reduce'
import { fromJS } from 'immutable'
import {
  GET_LIST_DATA,
  GET_LISTS_DATA,
  CREATE_LIST,
  UPDATE_LIST,
  DELETE_LIST,
  setListsDataProcessing,
  setList,
  setListsData,
  setListsDataError,
  getListsData,
  setNewList,
  setUpdatedList,
} from './actions'
import { getList, getLists, createList, updateList, deleteList } from '..'

const log = console

async function getListDataHandler ({ store, payload }) {
  const { language, id } = payload
  const { config, auth } = store.getState()
  try {
    store.dispatch(setListsDataProcessing({}))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      language,
      id,
    }
    const list = await getList(options)

    store.dispatch(
      setList({
        data: fromJS(list),
      }),
    )
    store.dispatch(setListsDataProcessing({ processing: false }))
  } catch (error) {
    log.error(error, 'Error getting list')
    store.dispatch(
      setListsDataError({
        error,
      }),
    )
  }
}

async function getListsDataHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setListsDataProcessing({}))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      language: payload,
    }
    const data = await getLists(options)
    const lists = _get(data, 'lists')
    const keyed = _reduce(
      lists,
      (obj, list) => {
        obj[list.id] = list // eslint-disable-line no-param-reassign
        return obj
      },
      {},
    )

    const unsorted = fromJS(keyed)
    const sorted = unsorted.sortBy((f) => f.get('adminTitle').toLowerCase())
    store.dispatch(
      setListsData({
        data: sorted,
      }),
    )
    store.dispatch(setListsDataProcessing({ processing: false }))
  } catch (error) {
    log.error(error, 'Error getting list')
    store.dispatch(
      setListsDataError({
        error,
      }),
    )
  }
}

async function updateListHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  const listId = _get(payload, 'data.listId')

  try {
    store.dispatch(setListsDataProcessing({}))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      data: payload,
      listId,
    }
    const results = await updateList(options)
    if (results) {
      store.dispatch(getListsData(_get(payload, 'language')))
      store.dispatch(setUpdatedList(_get(results, 'id')))
    }
    alert('List successfully updated')
  } catch (error) {
    log.error(error, 'Error updating section')
    store.dispatch(
      setListsDataError({
        error,
      }),
    )
  }
}

async function createListHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setListsDataProcessing({}))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      data: payload,
    }
    const results = await createList(options)

    if (results) {
      store.dispatch(getListsData(_get(payload, 'language')))
      store.dispatch(setNewList(_get(results, 'id')))
    }
    alert('List successfully created')
  } catch (error) {
    log.error(error, 'Error updating section')
    alert(error)
    store.dispatch(
      setListsDataError({
        error,
      }),
    )
  }
}

async function deleteListHandler ({ store, payload }) {
  const { config, auth } = store.getState()

  try {
    store.dispatch(setListsDataProcessing({}))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      id: _get(payload, 'id'),
    }

    await deleteList(options)
    store.dispatch(getListsData(_get(payload, 'language')))
  } catch (error) {
    log.error(error, 'Error updating section')
    store.dispatch(
      setListsDataError({
        error,
      }),
    )
  }
}

export default (store) => (next) => (action) => {
  const { type, payload } = action
  switch (type) {
    case GET_LIST_DATA:
      getListDataHandler({ store, payload })
      break
    case GET_LISTS_DATA:
      getListsDataHandler({ store, payload })
      break
    case CREATE_LIST:
      createListHandler({ store, payload })
      break
    case UPDATE_LIST:
      updateListHandler({ store, payload })
      break
    case DELETE_LIST:
      deleteListHandler({ store, payload })
      break
    default:
      break
  }
  next(action)
}
